import { gql } from '@apollo/client'

export const VALIDATE_AND_SAVE_USER_ADDRESS = gql`
  mutation VALIDATE_AND_SAVE_USER_ADDRESS($input: SaveAddressInput!) {
    validateAndSaveUserAddress(input: $input) {
      code
      success
      message
    }
  }
`

export const VALIDATE_AND_SAVE_SHIPPING_ADDRESS = gql`
  mutation VALIDATE_AND_SAVE_SHIPPING_ADDRESS($input: UpdateShippingAddressInput!) {
    updateShippingAddress(input: $input) {
      code
      success
      message
    }
  }
`

export const COLLECTIBLE_SEND_AS_GIFT = gql`
  mutation CollectiblesSendAsGift($input: CollectibleSendAsGiftInput!) {
    collectiblesSendAsGift(input: $input) {
      success
      message
    }
  }
`

export const CREATE_COLLECTIBLES_PRODUCT_PAYMENT_INTENT = gql`
  mutation CollectiblesCreateProductPaymentIntent($offers: [CollectibleOfferInput]!) {
    collectiblesCreateProductPaymentIntent(offers: $offers) {
      code
      message
      node {
        ... on CollectibleOffer {
          name
          products {
            ... on CollectibleProductMoment {
              description
              name
              price
            }
          }
        }
        ... on NFTPackPaymentIntent {
          chargeAmount
          paymentMethods {
            id
            created
            brand
            expYear
            last4
          }
          order {
            id
            shippingAddress {
              line1
              line2
              city
              state
              zip
              country
            }
          }
          defaultPaymentMethodId
          hasTaxIncluded
          isCreditOnly
          piid
          price
          spiid
          tax
        }
        ... on CollectiblesOrder {
          id
        }
      }
      success
    }
  }
`

export const CANCEL_PAYMENT_INTENT = gql`
  mutation CANCEL_PAYMENT_INTENT($input: CancelPaymentIntentInput!) {
    cancelNFTPaymentIntent(input: $input) {
      code
      success
      message
    }
  }
`

export const UPDATE_PRODUCT_PAYMENT_INTENT = gql`
  mutation UPDATE_COLLECTIBLES_PRODUCT_PAYMENT_INTENT($offers: [CollectibleOfferInput]!) {
    collectiblesUpdateProductPaymentIntent(offers: $offers) {
      code
      message
      success
      node {
        ... on CollectibleOffer {
          name
          products {
            ... on CollectibleProductMoment {
              description
              name
              price
            }
          }
        }
        ... on NFTPackPaymentIntent {
          chargeAmount
          paymentMethods {
            id
            created
            brand
            expYear
            last4
          }
          order {
            id
            shippingAddress {
              line1
              line2
              city
              state
              zip
              country
            }
          }
          defaultPaymentMethodId
          hasTaxIncluded
          isCreditOnly
          piid
          price
          spiid
          tax
        }
        ... on CollectiblesOrder {
          id
        }
      }
    }
  }
`

export const UPDATE_DEFAULT_PAYMENT_METHOD = gql`
  mutation UPDATE_DEFAULT_PAYMENT_METHOD($input: UpdateDefaultPaymentMethodInput!) {
    updateDefaultPaymentMethod(input: $input) {
      defaultPaymentMethodId
    }
  }
`

export const UPDATE_PAYMENT_METHOD = gql`
  mutation UPDATE_PAYMENT_METHOD($input: UpdateDefaultPaymentMethodInput!) {
    updatePaymentMethod(input: $input) {
      paymentMethodId
    }
  }
`

export const DELETE_PAYMENT_METHOD = gql`
  mutation DELETE_PAYMENT_METHOD($input: PaymentMethodInput!) {
    deletePaymentMethod(input: $input) {
      success
      message
    }
  }
`

export const CONFIRM_ANGEL_CHECKOUT_MUTATION = gql`
  mutation ConfirmAngelCheckout($input: ConfirmAngelCheckoutInput!) {
    confirmAngelCheckout(input: $input) {
      success
    }
  }
`

export const COMPLETE_NFT_PACK_WALLET_PURCHASE = gql`
  mutation COMPLETE_NFT_PACK_WALLET_PURCHASE($input: NFTPackPaymentCompletionInput!) {
    completeNFTPackWalletPurchase(input: $input) {
      status
      niftys {
        id
      }
    }
  }
`

export const COMPLETE_NFT_TRANSFER_WALLET_PURCHASE = gql`
  mutation COMPLETE_NFT_TRANSER_WALLET_PURCHASE($listingId: Int) {
    completeNFTTransferWalletPurchase(listingId: $listingId) {
      status
    }
  }
`

export const SET_FUTURE_USAGE_ON_PAYMENT_INTENT = gql`
  mutation SET_FUTURE_USAGE_ON_PAYMENT_INTENT($input: setFutureUsageOnPaymentIntentInput!) {
    setFutureUsageOnPaymentIntent(input: $input) {
      success
      message
    }
  }
`
